import { getCoreDataSecurityDataAccessPermissionSourcesSlice } from './get';

export const {
	requestGetCoreDataSecurityDataAccessPermissionSources,
	resetGetCoreDataSecurityDataAccessPermissionSources
} =
	getCoreDataSecurityDataAccessPermissionSourcesSlice.asyncActionCreators;
